import React from "react"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import { SlArrowRight } from "react-icons/sl"
import { IconContext } from "react-icons"
import { Link } from "gatsby"
import clsx from "clsx"

export default function CardNews({ data, width = "constrained" }) {
  return (
    <div
      className={clsx(
        "relative rounded-[60px] overflow-hidden bg-white card-list-item w-full",
        width === "constrained" ? "max-w-[300px] " : ""
      )}
    >
      <Link
        to={data.uri}
        className="absolute inset-0 w-full h-full rounded-[60px] z-20"
      ></Link>
      <div className="w-full aspect-video">
        <GatsbyImage
          alt="image"
          image={getImage(data.featuredImage.node.gatsbyImageData)}
          className="object-cover w-full h-full overflow-hidden [&_img]:rounded-t-[60px]"
        />
      </div>

      <div className="px-8 py-6 space-y-3 text-dark">
        <h4 className="heading card-slide-h">{data.title}</h4>
        <div
          className="text-xs line-clamp-4"
          dangerouslySetInnerHTML={{ __html: data.excerpt }}
        ></div>
        <IconContext.Provider value={{ size: 10 }}>
          <Link
            to={data.uri}
            className="inline-flex space-x-1 text-sm leading-none"
          >
            <SlArrowRight />
            <span>Read more</span>
          </Link>
        </IconContext.Provider>
      </div>
    </div>
  )
}
